




































































































































































































































































































































import { Component, Vue, Prop, Watch, PropSync, InjectReactive, Ref } from 'vue-property-decorator';
import { GQL_EmployeeCreate, GQL_EmployeeUpdate } from '@/queries/global';
import { IRules } from '@/components/UI/Form/ValidationModule';
import {
  validateRequired, validateType,
  validateMod11, validateMin, validateLength,
  allowEmpty,
 } from '@/components/UI/Form/Validations';
import PhoneInput from '@/components/PhoneInput.vue';
import { SmartQuery } from 'vue-apollo-decorator';
import { socialNumberModValidation } from './EmployeeSearch.vue';
import { isValidSwift } from '@/app/swift';
import { isValidIban } from '@/app/Iban';
import { ALL_COUNTRIES } from '@/queries/Country';
import { GQL_allCountries_allCountries } from '@/queries/__generated__/allCountries';
import { birthDateMatchesSsn, norwegianSsnToBirthDate } from '@/app/Employee';
import { postCityForZip } from '@/utils/postal-code';
import SForm from '@/components/UI/Form/SForm.vue';

@Component({
  components: {
    PhoneInput,
  },
})
export default class EmployeeForm extends Vue {
  @SmartQuery(ALL_COUNTRIES) private allCountries!: GQL_allCountries_allCountries[];

  @Prop({ type: Object, required: true }) private employee!: GQL_EmployeeCreate | GQL_EmployeeUpdate;
  @PropSync('valid', { type: Boolean, default: true }) private validFormSync!: boolean;
  @PropSync('dirty', { type: Boolean, default: false }) private dirtyFormSync!: boolean;

  @Ref() public readonly form?: SForm;

  @InjectReactive() private editable!: boolean;

  private editableSsn!: boolean;

  private rules: IRules = {
    firstName: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('Employee', 'firstName') }) } ],
    lastName: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('Employee', 'lastName') }) } ],
    birthDate: [
      { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('Employee', 'birthDate') }) },
      { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
      {
        validation: ({ formElements }) => {
          if (formElements.confirmBirthDateMismatch?.dataValue) return true;
          return !this.differentDateFromSsn;
        },
        message: i18n => i18n.t('GQL.ValidationType.does_not_match_ssn', { expected: norwegianSsnToBirthDate(this.employee.socialSecurityNumber || '', this.employee.temporarySocialSecurityNumber || '')}),
        triggerBy: [ 'confirmBirthDateMismatch', 'socialSecurityNumber' ],
      },
    ],
    birthDateMismatchReason: [
      {
        validation: ({ formElements, dataValue }) => {
          if (!formElements.confirmBirthDateMismatch?.dataValue) return true;

          return !!dataValue;
        },
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Employee', 'birthDateMismatchReason') }),
        triggerBy: [ 'confirmBirthDateMismatch' ],
      },
    ],
    socialSecurityNumber: [
      allowEmpty({
        validation: validateLength(11),
        message: i18n => i18n.t('Error.length', { length: 11 }),
      }),
      allowEmpty({
        validation: socialNumberModValidation,
        message: i18n => i18n.t('Error.invalid', { field: this.t_attr('Employee', 'socialSecurityNumber') }),
      }),
    ],
    address: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: i18n.t('Address.address') }) } ],
    city: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: i18n.t('Address.city') }) } ],
    zip: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: i18n.t('Address.zip') }) } ],
    countryCode: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: i18n.t('Address.country') }) } ],
    bban: [
      {
        validation: validateRequired(),
        if: ({ formElements }) => {
          if (
            !formElements.iban ||
            !formElements.swift
          ) return true;

          if (
            !formElements.iban.dataValue &&
            !formElements.swift.dataValue
          ) return true;

          return false;
        },
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Employee', 'bban') }),
        triggerBy: [ 'iban', 'swift' ],
      },
      { validation: validateMod11(), message: i18n => i18n.t('Error.invalid', { field: this.t_attr('Employee', 'bban') }) },
    ],
    iban: [
      {
        validation: validateRequired(),
        if: ({ formElements }) => {
          if (
            !formElements.bban ||
            !formElements.swift
          ) return true;

          if (
            !formElements.bban.dataValue
          ) return true;

          if (
            formElements.swift.dataValue
          ) return true;

          return false;
        },
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Employee', 'iban') }),
        triggerBy: [ 'bban', 'swift' ],
      },
      { validation: ({dataValue}) => !dataValue || isValidIban(dataValue), message: i18n => i18n.t('Error.invalid', { field: this.t_attr('Employee', 'iban') }) },
    ],
    swift: [
      {
        validation: validateRequired(),
        if: ({ formElements }) => {
          if (
            !formElements.bban ||
            !formElements.iban
          ) return true;

          if (
            !formElements.bban.dataValue
          ) return true;

          if (
            formElements.iban.dataValue
          ) return true;

          return false;
        },
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Employee', 'swift') }),
        triggerBy: [ 'bban', 'iban' ],
      },
      { validation: ({dataValue}) => !dataValue || isValidSwift(dataValue), message: i18n => i18n.t('Error.invalid', { field: this.t_attr('Employee', 'swift') }) },
    ],
    vacationMoneyPercentage: [ { validation: validateType('unumber'), message: i18n => i18n.t('GQL.Type.unumber') } ],
    creditDays: [ { validation: validateMin(0), message: i18n => i18n.t('Error.required', { field: this.t_attr('Employee', 'creditDays') }) } ],
  };

  private confirmBirthDateMismatch = false;

  private created(): void {
    this.setSsnEditing();
    this.confirmBirthDateMismatch = !!this.employee.birthDateMismatchReason;
  }

  public setSsnEditing(): void {
    // If it's the case that employee has TSSN, and not SSN,
    // we should make SSN editable.
    // If the employee already has SSN upon loading or after saving,
    // we should not be able to change it.
    this.editableSsn = !this.employee.socialSecurityNumber;
  }

  @Watch('employee.countryCode', { immediate: true })
  private setPhoneCountryCode(): void {
    if (!this.employee.phoneCountryCode) {
      this.employee.phoneCountryCode = this.employee.countryCode;
    }

    function userHasId(user: GQL_EmployeeCreate | GQL_EmployeeUpdate): user is GQL_EmployeeUpdate {
      return !!(user as unknown as { id?: string }).id;
    }

    if (!userHasId(this.employee) && !this.employee.user.cellphoneCountryCode) {
      // This should only be set for new employees.
      this.employee.user.cellphoneCountryCode = this.employee.countryCode;
    }
  }

  @Watch('employee.creditDays')
  private creditDaysToNumber(): void {
    if (this.employee.creditDays) {
      this.employee.creditDays = Number(this.employee.creditDays);
    }
  }

  @Watch('differentDateFromSsn')
  private showMismatchReason(): void {
    this.employee.birthDateMismatchReason = null;
    this.confirmBirthDateMismatch = false;
  }

  private get differentDateFromSsn() {
    return !birthDateMatchesSsn(
      this.employee.birthDate,
      this.employee.socialSecurityNumber || null,
      this.employee.temporarySocialSecurityNumber || null,
    );
  }

  private async fillCity(): Promise<void> {
    const city = await postCityForZip(this.$apollo, this.employee);

    if(city) this.employee.city = city;
  }

  private get country(): string {
    const country = this.allCountries.find(c => c.code === this.employee.countryCode);
    return country ? country.name : '';
  }
}
